import Product from "../pages/Product";
import ProductOld from "../pages/ProductOld";
import NewsEvents from "../pages/NewsEvents/NewsEvents";
import Write from "../pages/Write";
import About from "../pages/About";
// Settings page uses EditProfile component
import MyProfile from "../pages/MyProfile";
import Home from "../pages/Home";
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import Contact from "../pages/Contact";
import Registration from "../pages/Registration";
import Login from "../pages/Signin";
import EditProfile from "../pages/EditProfile";
import Suspension from "../pages/Suspension";
import Users from "../pages/Users";
import Support from '../pages/Support';
import UserProfile from '../pages/UserProfile';

const isUserSuspended = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) {
      console.warn("User is null – treating as not suspended");
      return false; // or redirect to login, or handle gracefully
  }
  console.log("is_suspended: ", user.suspended);
  return user.suspended;
};

const _routes = [
    {title: "Home", name: 'Home', path: "/", exact: true, public: true, component: Home},
    {title: "News & Events", name: 'NewsEvents', path: "/news-events", public: true, component: NewsEvents},
    {title: "Sponsors' Products", name: 'Products', path: "/products", public: true, component: Product},
    {title: "Sponsors' Products (Old)", name: 'ProductsOld', path: "/products-old", public: true, component: ProductOld},
    {title: "About", name: 'About', path: "/about", public: true, component: About},
    {
        title: "Edit Post",
        name: "EditPost",
        path: isUserSuspended() ? "/suspension" : "/write/:postId", // Edit existing post - must come before /write
        public: false,
        component: isUserSuspended() ? Suspension : Write,
      },
    {
        title: "Write",
        name: "Write",
        path: isUserSuspended() ? "/suspension" : "/write", // Redirect to suspension if suspended
        exact: true,
        public: false,
        component: isUserSuspended() ? Suspension : Write, // Load appropriate component
      },
    {title: "Support", name: 'Support', path: "/support", public: true, component: Support},
    {title: "MyProfile", name: 'MyProfile', path: "/myprofile", public: false, component: MyProfile},
    {title: "User Profile", name: 'UserProfile', path: "/profile/:userId", public: true, component: UserProfile},
    {title: "Settings", name: 'Settings', path: "/settings", public: false, component: EditProfile},
    {title: "Settings", name: 'EditProfile', path: "/editprofile", public: false, component: EditProfile},
    {title: "Suspension", name: 'Suspension', path: "/suspension", public: false, component: Suspension},
    {title: "Users", name: 'Users', path: "/users", public: false, component: Users},
    {title: 'Contact', name: 'Contact', path: '/contactus', public: true, component: Contact},
    {title: "Reset Password", name: 'ResetPassword', path: "/reset-password/:token", public: true, component: ResetPassword},
]

const _login_routes = [
    {title: "Sign-In", name: 'Login', path: "/login", exact: true, component: Login},
    {title: "Registration", name: 'Registration', path: "/registration", component: Registration},
    {title: "Forgot Password", name: 'Forgot-password', path: "/login/forgot-password", component: ForgotPassword},
    {title: "Reset Password", name: 'Reset-password', path: "/login/reset-password/:token", component: ResetPassword}
]

const routesMap = (routesToFilter, routes) => (routes || _routes).filter(route => routesToFilter.includes(route.name.toLowerCase()));
export const routesBeforeLogin = () => routesMap(['home', 'about', 'newsevents', 'products']);
export const routesAfterLogin = () => routesMap(['home', 'about', 'newsevents', 'products', 'write']);
export const routes = (routesToFilter) => routesMap(routesToFilter, _login_routes);
export const allRoutes = _routes;
export const loginRoutes = _login_routes;
